export default "__VITE_ASSET__DrBrTeZK__"